import React, { useMemo } from 'react'
import { TextField } from '@material-ui/core'
import { TextFieldProps } from '@material-ui/core/TextField'
// import { makeStyles } from '@material-ui/core/styles'

// const useStyles = makeStyles(theme => ({
//   validationInput: {}
// }))

const ValidationAndLimitLengthInput: React.FC<
  {
    value: string
    invalidStr: RegExp
    strLength: number
    validationErrorMessage?: string
    strLengthErrorMessage?: string
    inputHandler: (input: string) => void
    validationStateChange?: (isFullFilled: boolean) => void
    required: boolean
  } & TextFieldProps
> = props => {
  const {
    value,
    label,
    required,
    fullWidth,
    invalidStr,
    strLength,
    validationErrorMessage,
    strLengthErrorMessage,
    inputHandler,
    validationStateChange
  } = props

  const isValid = useMemo<boolean>(() => {
    // 無効な文字列に引っかかったらvalidStateにはfalseが入る
    return !invalidStr.test(value)
  }, [invalidStr, value])

  const isStrLengthValid = useMemo<boolean>(() => {
    // valueがstrLength以上ならvalidStateにはfalseが入る
    return value.length <= strLength
  }, [strLength, value])

  useMemo<boolean>(() => {
    const fullFilledState = isValid && isStrLengthValid
    validationStateChange(fullFilledState)
    return fullFilledState
  }, [isValid, isStrLengthValid])

  return (
    <TextField
      value={value}
      error={!isValid || !isStrLengthValid || (required && !value.length)}
      required={required}
      label={label}
      variant="outlined"
      fullWidth={fullWidth}
      onChange={event => inputHandler(event.target.value)}
      helperText={
        (!isValid && validationErrorMessage) ||
        (!isStrLengthValid && strLengthErrorMessage) ||
        (required && !value.length && '必須入力です。')
      }
    />
  )
}

export default ValidationAndLimitLengthInput
